import React from 'react';
import {
  Dialog, DialogTitle, DialogContent,
  TextField, DialogActions, Button
} from '@mui/material';

const SourceLocationDialog = ({ 
  dialogOpen, setDialogOpen, 
  fullDepthSgeFile, setFullDepthSgeFile }) => {
  
  return (
    <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
      <DialogTitle>Source Location</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          margin="dense"
          label="Full-dept SGE FlatGeobuf"
          value={fullDepthSgeFile}
          onChange={(e) => setFullDepthSgeFile(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setDialogOpen(false)} color="primary">
          Cancel
        </Button>
        <Button onClick={() => {
          setDialogOpen(false);
        }} color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SourceLocationDialog;

